import { useEffect, useRef, useState } from 'react';
import { ServiceRegister } from './api';
import {
    classifyReferralError,
    classifyReferralResult,
    forgetReferral,
    markReferralValid,
    readReferral,
    ReferralCheck,
} from './referral';

/**
 * The referral code captured from `?ref=`, checked once against the public
 * endpoint. Only a definite "not valid" drops it; a 429 or a network error
 * keeps it silently and lets CompleteSignup decide.
 */
export function useReferral() {
    const [referral, setReferral] = useState(readReferral);
    const [check, setCheck] = useState<ReferralCheck | undefined>(() =>
        referral?.partnerDisplayName ? { kind: 'valid', partnerDisplayName: referral.partnerDisplayName } : undefined,
    );
    const started = useRef(false);

    useEffect(() => {
        if (started.current || !referral || check) return;
        started.current = true;
        const code = referral.code;
        (async () => {
            let result: ReferralCheck;
            try {
                result = classifyReferralResult(await ServiceRegister.validateReferralCode(code));
            } catch (err) {
                result = classifyReferralError(err);
            }
            if (result.kind === 'valid') {
                markReferralValid(code, result.partnerDisplayName);
            } else if (result.kind === 'invalid') {
                forgetReferral();
                setReferral(undefined);
            }
            setCheck(result);
        })();
    }, [referral, check]);

    return { code: referral?.code, check };
}
